/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_SendInputs */

const en_share_send = /** @type {(inputs: Share_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share …`)
};

const de_share_send = /** @type {(inputs: Share_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilen …`)
};

/**
* | output |
* | --- |
* | "Share …" |
*
* @param {Share_SendInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const share_send = /** @type {((inputs?: Share_SendInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_SendInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_share_send(inputs)
	return en_share_send(inputs)
});